// @ts-ignore
import Sortable from "sortablejs";
import { ApiService, Category} from "../libs";
import { DataService } from './data';
import {CompService} from './comp';
import Message from './message';

let dragToTreeIns: any = [];

export class DragService {
  static dragStartDisable(operateAreaId: number[]) {
    const arrData: any = document.querySelectorAll('.mask-disable-drag') || [];
    arrData.forEach((item: any) => {
      const check = operateAreaId.find((v: number) => (item.className.includes(`${v}`)));
      if (!check) {
        item.style.display = 'block';
      }
    })
  }
  static dragEndUnDisable() {
    const arrData: any = document.querySelectorAll('.mask-disable-drag') || [];
    arrData.forEach((item: any) => {
      item.style.display = 'none';
    })
  }

  // 树节点拖拽
  static dragTree(callback: any = null, dirCategoryId: any) {
    const treeNodes = document.querySelectorAll('.el-tree-node__content');
    [].forEach.apply(treeNodes, [(element: any) => {
      let toId: any, fromId: any, drag: boolean = true, fromDirId: any, parentIDPath: string = '', toIsShare: number,
        fromIsShare: number, category: number, fromCategory: number;
      let config = {
        sort: false,
        delay: 50,
        forceFallback: true,
        fallbackClass: "drag-ghost",
        group: {
          name: "dragGroup",
          pull: (obj: any) => {
            if (fromId <= 0) {
              return false;
            }
            let treeSpan = obj.el.querySelector('.tree-span');
            let dragTo = document.querySelector('.drag-to');
            let forbid = document.querySelector('.forbid');

            dragTo && dragTo.classList.remove('drag-to');// 增加drag-to类名  用于改变被放置节点的样式
            forbid && forbid.classList.remove('forbid');

            if (treeSpan) {
              toId = treeSpan.dataset['id'];
              toIsShare = treeSpan.dataset['isShare'];
              parentIDPath = treeSpan.dataset['parentIdPath'];
              category = treeSpan.dataset['category'];
              let parentIDs = parentIDPath ? parentIDPath.split("L") : []; // 自己和后代节点 禁用样式；
              if (toIsShare || fromIsShare || toId < 0 || toId == fromId || parentIDs.indexOf(fromId) != -1) {
                treeSpan.parentNode.parentNode.classList.add('forbid');
              } else {
                treeSpan.parentNode.parentNode.classList.add('drag-to');
              }
            } else {
              toId = null;
              fromId = null;
            }

            return false;
          }
        },
        onStart: (obj: any) => {
          let fromSpan = obj['from'].querySelector('.tree-span');
          if (fromSpan) {
            fromId = fromSpan.dataset['id'];
            fromIsShare = fromSpan.dataset['isShare'];
            fromDirId = fromSpan.dataset['parentid'];
            fromCategory = fromSpan.dataset['category'];
            drag = fromSpan.dataset['drag'] == 1 ? true : false;
            if (!drag) {
              Message.warning("此目录不能拖动");
            }

            if (fromCategory) {
              this.dragStartDisable([fromCategory]);
            }
          }
        },
        onEnd: (obj: any) => {
          this.dragEndUnDisable();

          let dragTo = document.querySelector('.drag-to');
          let forbid = document.querySelector('.forbid');

          dragTo && dragTo.classList.remove('drag-to');
          forbid && forbid.classList.remove('forbid');

          let node = document.querySelectorAll('.el-tree-node__content');
          if (!drag) {
            return;
          }

          if (fromCategory !== category) {
            DragService.pointerEvents(node, 'auto');
            return;
          }

          DragService.pointerEvents(node, 'none');
          if (toIsShare || fromIsShare || toId < 0 || !toId || toId == fromId) {
            setTimeout(() => {
              DragService.pointerEvents(node, 'auto');
            })
            return false;
          }

          let parentIDs = parentIDPath ? parentIDPath.split("L") : [];
          // 确保不是移动到自己的后代节点
          if (parentIDs.indexOf(fromId) == -1) {
            let url: any;
            let dirIdArray: Array<Number> = [fromId];
            url = `${ApiService.JrzzApi}/dir/${dirCategoryId}/move?toDirId=${toId}&fromDirId=${fromDirId || 0}`;
            DataService.post(url, dirIdArray).then(res => {
              if (res) callback && callback({toId, fromId});
              toId = null;
              fromId = null;
              DragService.pointerEvents(node, 'auto');
            })
          } else {
            toId = null;
            fromId = null;
            DragService.pointerEvents(node, 'auto');

          }
        }
      }
      // if(parentIDPath) {
      Sortable.create(element, config);
      // }
    }])
  }

  // 列表拖拽到树
  static dragToTree(params: any) {
    dragToTreeIns.length > 0 && dragToTreeIns.forEach((ins: any) => {
      ins.el && ins.destroy();
    })
    let table = params.table || document.getElementsByClassName('el-table__body-wrapper')[0];
    if (!table) {
      return
    }
    let tableRow = table && table.querySelectorAll(params.wrapper || 'tbody');
    [].forEach.apply(tableRow, [(element: any, index: number) => {
      let secondKey = params.secondKey || '';
      let primaryKey = params.primaryKey || "ID";
      let callback = params.callback || null;
      // const tbody: any = document.querySelector(params.className);
      let treeId: any = null, treeDirCategoryId: any = null, drag: boolean = true, rowIndex, rowDirId: number, row: any, dirOwner: any,
        dirName: string,
        parentIDPath: string;
      let config: any = {
        sort: false,
        filter: params.filter || '', // 'filtered' class is not draggable
        delay: params.hasOwnProperty('delay') ? params.delay : 30,
        forceFallback: true,
        fallbackClass: "drag-ghost",
        group: {
          name: "dragGroup",
          pull: (obj: any) => {
            let treeSpan = obj.el.querySelector('.tree-span');
            let dragTo = document.querySelector('.drag-to');
            let forbid = document.querySelector('.forbid');
            dragTo && dragTo.classList.remove('drag-to');
            forbid && forbid.classList.remove('forbid');

            // 禁止出现拖动消失效果
            if (treeSpan) {
              dirOwner = treeSpan.dataset['owner'];
              treeId = treeSpan.dataset['id'];
              treeDirCategoryId = treeSpan.dataset['dircategory'];
              dirName = treeSpan.innerText;
              parentIDPath = treeSpan.dataset['parentIdPath'];
              drag = treeSpan.dataset['drag'] == 1 ? true : false;
              if (treeId == 0) {
                treeSpan.parentNode.parentNode.classList.add('drag-to');
                return false;
              }
              treeSpan.parentNode.parentNode.classList.add('drag-to');
            } else {
              treeId = null;
              row = null
            }
            return false;
          }
        },
        onEnd(obj: any) {
          DragService.dragEndUnDisable();

          let dragTo = document.querySelector('.drag-to');
          let forbid = document.querySelector('.forbid');
          dragTo && dragTo.classList.remove('drag-to');
          forbid && forbid.classList.remove('forbid');

          params.specialHandler && params.specialHandler('end')

          let toClassName = obj.originalEvent.srcElement.parentElement.className; // 鼠标移开tree 不再执行
          if (typeof toClassName !== 'string') {
            return false;
          }
          if (toClassName.indexOf('tree-node') == -1) {
            return false;
          }
          if (!drag) {
            Message.warning("无法拖拽到此目录");
            return false;
          }
          //  // 没有选择目录时 推拽无效
          // if(!row.DirID) {
          //   return false;
          // }
          if (row.DirID == treeId) {
            Message.warning("已经在当前目录下");
            return false;
          }
          if (treeId === null) {
            return false;
          }

          let node = document.querySelectorAll('.el-tree-node__content');
          DragService.pointerEvents(node, 'none');
          // 目录中不存在往目录中添加内容
          if (row.isAdd) {
            CompService.enterpriseExist(row.CompID, true).then(res => {
              if (res) {
                Message.warning('资源已存在');
                DragService.pointerEvents(node, 'auto');
              } else {
                // 加入我的资源
                CompService.enterpriseInsert(
                  treeId,
                  treeDirCategoryId,
                  row.CompID,
                  row.MainProduct,
                  row.CompName,
                ).then(res => {
                  if (res) {
                    Message.success("操作成功");
                  }
                  DragService.pointerEvents(node, 'auto');
                  callback && callback({
                    row, // 当前操作的数据源
                    treeId, // 目的树的目录id
                    dirCategoryId: params.dirCategory, // 源数据的目录类别id
                    treeDirCategoryId, // 目的树的目录类别id
                    dirName, // 目的树的目录名称
                    copy: false, // 当前操作是否为拷贝
                  });
                }).catch(() => {
                  DragService.pointerEvents(node, 'auto');
                });
              }
            });
          } else {
            let url: any;
            url = `${ApiService.JrzzApi}/data/${params.dirCategory}/${params.category}/move?toDirCategoryId=${treeDirCategoryId}&toCategoryId=${params.category}`;
            let moveData = {
              'DataIdArray': secondKey ? [row[primaryKey][secondKey]]: [row[primaryKey]],
              'FromDirId': row.DirID,
              'ToDirId': treeId,
            };
            // 如果是移动到不同的目录类别下，则是拷贝，不需要FromDirId字段
            let copy = treeDirCategoryId != params.dirCategory;
            if (copy) {
              delete moveData.FromDirId;
            }
            DataService.post(url, moveData).then(res => {
              if (res) {
                Message.success("更改目录成功");
              }
              DragService.pointerEvents(node, 'auto');
              // 拖拽完成后的回调
              callback && callback({
                row, // 当前操作的数据源
                treeId, // 目的树的目录id
                dirCategoryId: params.dirCategory, // 源数据的目录类别id
                treeDirCategoryId, // 目的树的目录类别id
                dirName, // 目的树的目录名称
                copy, // 当前操作是否为拷贝
              });
            }).catch(() => {
              DragService.pointerEvents(node, 'auto');
            })
          }
        },
        onStart(obj: any) {
          // 拖拽开始时 取出拖拽行的ID 及 DirID
          rowIndex = obj.oldIndex;
          row = params.datas[rowIndex];
          if (!row) {
            if(params.secondKey) {
              row = params.datas.find((item: any) => item[params.primaryKey][params.secondKey] == obj.srcElement.dataset.id)
            }else {
               row = params.datas.find((item: any) => item[params.primaryKey] == obj.srcElement.dataset.id)
            }
           
          }
          params.specialHandler && params.specialHandler('start');

          if (params.operateAreaId) {
            DragService.dragStartDisable(params.operateAreaId);
          }
        }
      }
      //句柄，点击指定class样式的对象才能拖拽元素
      params.handle && (config.handle = params.handle);
      dragToTreeIns.push(Sortable.create(element, config));
    }])
  }

  static pointerEvents(eles: any, str: string) {
    [].forEach.apply(eles, [(ele: any, index: number) => {
      ele.style.pointerEvents = str
    }])
  }
}
